import type { ReactNode } from 'react';

import { Icons, NoData, Stack } from '@cast/design-system';
import { useReportingTrial, useTrial } from '@cast/shared-trial-ui';

import { ConnectClusterButton } from './ConnectClusterButton';
import { TrialInfoCards } from './TrialInfoCards';

export const ClustersEmptyState = ({
  onConnectCluster,
  isConnectClusterDisabled,
  banner,
}: {
  onConnectCluster?: () => void;
  isConnectClusterDisabled?: boolean;
  /** Optional banner below Connect (e.g. reporting trial connection alert). */
  banner?: ReactNode;
}) => {
  const { isPreTrial } = useTrial();
  const { isEligible: isReportingEligible } = useReportingTrial();

  return (
    <Stack gap={24}>
      <NoData
        icon={<Icons.Clock />}
        title="Connect your clusters"
        body="Add your first Kubernetes cluster to monitor resources, optimize workloads, and track costs across your fleet."
        actions={
          <Stack gap={16} alignItems="center">
            <ConnectClusterButton
              variant="primary"
              size="md"
              onConnectCluster={onConnectCluster}
              disabled={isConnectClusterDisabled}
            />
            {banner}
          </Stack>
        }
        testId="clusters-empty-state"
      />
      {isPreTrial && !isReportingEligible && <TrialInfoCards />}
    </Stack>
  );
};
